import { baseApi } from '../baseApi';
import type { 
  SubscriptionListResponse, 
  ConsumptionLogSummary, 
  ConsumptionLogsResponse 
} from '@/types/subscriptions';

export const subscriptionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // List user subscriptions
    listUserSubscriptions: builder.query<SubscriptionListResponse, { is_active?: boolean }>({
      query: (params) => ({
        url: '/marketplace/subscriptions',
        params,
      }),
      providesTags: ['User'],
    }),
    
    // Get consumption logs summary
    getConsumptionLogsSummary: builder.query<ConsumptionLogSummary, string>({
      query: (subscriptionId) => ({
        url: `/marketplace/subscriptions/${subscriptionId}/consumption-logs/summary`,
      }),
      providesTags: (_, __, subscriptionId) => [
        { type: 'User', id: subscriptionId },
      ],
    }),
    
    // Get consumption logs with pagination
    getConsumptionLogs: builder.query<ConsumptionLogsResponse, {
      subscriptionId: string;
      page?: number;
      limit?: number;
    }>({
      query: ({ subscriptionId, page = 1, limit = 10 }) => ({
        url: `/marketplace/subscriptions/${subscriptionId}/consumption-logs`,
        params: { page, limit },
      }),
      providesTags: (_, __, { subscriptionId }) => [
        { type: 'User', id: subscriptionId },
      ],
    }),
  }),
});

export const { 
  useListUserSubscriptionsQuery,
  useGetConsumptionLogsSummaryQuery,
  useGetConsumptionLogsQuery 
} = subscriptionsApi;
